export function gnav() {
    const open = document.querySelector(".js-gnav_open");
    const close = document.querySelectorAll(".js-gnav_close");

    open.addEventListener("click", () => {
        document.body.classList.add("-gnav_active");
        document.body.classList.add("-lock");
    });

    close.forEach(function (elm) {
        elm.addEventListener("click", () => {
            document.body.classList.remove("-gnav_active");
            document.body.classList.remove("-lock");
        });
    });
}
